import { useState } from 'react';
import { InputProps } from 'antd';
import Icon from '@ant-design/icons';
import SearchSvg from 'global/Icons/SearchSvg';
import CloseIconCircleSvg from 'global/Icons/CloseIconCircleSvg';
import { Input } from './styled';

type SearchInputProps = {
  onClear?: () => void;
} & InputProps;

const SearchInput = ({ onClear, ...props }: SearchInputProps) => {
  const [value, setValue] = useState(props.value || '');
  const inputValue = props.value || value;

  return (
    <Input
      prefix={
        <Icon
          component={SearchSvg}
          style={{ fontSize: 18, color: '#969696' }}
        />
      }
      suffix={
        onClear && inputValue ? (
          <Icon
            onClick={() => {
              setValue('');
              onClear();
            }}
            component={CloseIconCircleSvg}
            style={{ fontSize: 16, color: '#969696' }}
          />
        ) : undefined
      }
      {...props}
      onChange={(e) => {
        setValue(e.target.value);
        props.onChange?.(e);
      }}
      value={inputValue}
    />
  );
};

export default SearchInput;
